import * as z from "zod/v4";
import * as Option from "@gordonb/result/option";
import { NoteSchema } from "../note.ts";
import { CoerceSlugSchema, SlugSchema } from "../slug.ts";
import { ResultSchemaOf } from "../result.ts";
import {
  CoerceUnitIntervalSchema,
  UnitIntervalSchema,
} from "../unit-interval.ts";

export const ForceConnectionMetaSchema = z.object({
  strength: UnitIntervalSchema.default(0.5).describe(
    `Strength of the connection between forces (0-1)`,
  ),
  source: SlugSchema,
  target: SlugSchema,
});

export const ForceConnectionNoteSchema = NoteSchema.extend({
  type: z.literal("force-connection"),
  meta: ForceConnectionMetaSchema,
});

export type ForceConnectionNote = z.infer<typeof ForceConnectionNoteSchema>;

const CoerceForceConnectionMetaSchema = z.object({
  strength: z.preprocess(Option.from, CoerceUnitIntervalSchema.default(0.5)),
  source: CoerceSlugSchema,
  target: CoerceSlugSchema,
});

export const CoerceForceConnectionNoteSchema = ForceConnectionNoteSchema.extend(
  {
    meta: CoerceForceConnectionMetaSchema,
  },
);

export const ForceConnectionNoteArraySchema = z.array(
  ForceConnectionNoteSchema,
);

export type ForceConnectionNoteArray = z.infer<
  typeof ForceConnectionNoteArraySchema
>;

export const ForceConnectionNoteArrayResultSchema = ResultSchemaOf(
  ForceConnectionNoteArraySchema,
  z.string(),
);
export type ForceConnectionNoteArrayResult = z.infer<
  typeof ForceConnectionNoteArrayResultSchema
>;
